const sectionLabels = {
  0: {
    label: 'Root',
    stage: 'Root',
  },
  1: {
    label: 'Eligibility',
    stage: 'Eligibility',
  },
  2: {
    label: 'Personal details',
    stage: 'PersonalInfo',
  },
  3: {
    label: 'Personal finances',
    stage: 'PersonalFinances',
  },
  4: {
    label: 'Previous education',
    stage: 'PreviousEducation',
  },
  5: {
    label: 'Employment',
    stage: 'Employment',
  },
  6: {
    label: 'Loan details',
    stage: 'LoanDetails',
  },
  7: {
    label: 'Provisional Offer',
    stage: 'Submit',
  },
};

export default sectionLabels;
